import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Pagination, Container } from 'react-bootstrap';

const AdminTourInPersonPage = () => {
    const [tourInPersons, setTourInPersons] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);  // Number of items per page

    // Fetch TourInPerson Data
    useEffect(() => {
        const fetchTourInPersons = async () => {
            try {
                const response = await axios.get('https://api.biznetusa.com/api/get-tourinpersons');
                if (response.data.status === 200) {
                    // Sorting data to show latest on top
                    const sortedData = response.data.tour_in_person.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                    setTourInPersons(sortedData);
                }
            } catch (error) {
                console.error('Error fetching data', error);
            }
        };
        fetchTourInPersons();
    }, []);

    // Get current items for pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = tourInPersons.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Pagination logic
    const totalPages = Math.ceil(tourInPersons.length / itemsPerPage);

    return (
        <Container className="mt-5">
            <h2>Tour In Person Requests</h2>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Date</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Best Way to Contact</th>
                        <th>Notes</th>
                        <th>Financing Options</th>
                        <th>Working as Real Estate Agent</th>
                        <th>Agreement to Work with Agent</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.length > 0 ? (
                        currentItems.map((item) => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.date}</td>
                                <td>{item.firstname}</td>
                                <td>{item.lastname}</td>
                                <td>{item.email}</td>
                                <td>{item.phone}</td>
                                <td>{item.best_way_to_contact}</td>
                                <td>{item.notes ? item.notes : 'N/A'}</td>
                                <td>{item.financing_options ? 'Yes' : 'No'}</td>
                                <td>{item.working_as_realstate_agent ? 'Yes' : 'No'}</td>
                                <td>{item.agreement_committing_to_work_with_agent ? 'Yes' : 'No'}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="11">No Data Available</td>
                        </tr>
                    )}
                </tbody>
            </Table>

            {/* Pagination */}
            <Pagination>
                {[...Array(totalPages).keys()].map((number) => (
                    <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
                        {number + 1}
                    </Pagination.Item>
                ))}
            </Pagination>
        </Container>
    );
};

export default AdminTourInPersonPage;
